import InlineFormInput from "../../FormGroups/InlineFormInput";

export default function Edit({ command, commandIdx, control, errors }) {
    return (
        <InlineFormInput
            name={`commands.${commandIdx}.settings.period`}
            control={control}
            defaultValue={command.settings?.period || ""}
            errors={errors?.commands?.[commandIdx]?.settings?.period}
            placeholder=""
            inputType="text"
            unit="s"
        />
    );
}
